import { Routes } from "@angular/router";
import { AdvertisementIntegrationsPageComponent } from "./advertisement-integrations-page.component";
import { authGuard } from "../../../core/guards/auth.guard";

export const advertisementIntegrationsPageRoutes: Routes = [
  {
    path: 'records/advertisement-integrations',
    component: AdvertisementIntegrationsPageComponent,
    canActivate: [authGuard]
  }
]
